<div style="display: flex" *ngIf="formGroup" [formGroup]="formGroup">
  <mat-form-field
    class="form-field-s space-h-l"
    appearance="fill"
    [ngClass]="{ 'yield-field-error': formGroup.controls.yieldQuantity.invalid && formGroup.controls.yieldQuantity.touched }"
  >
    <mat-label>{{ 'NUMBER' | translate }}</mat-label>
    <input matInput formControlName="yieldQuantity" type="number" id="RecipesYieldQuantityTxt" min="0" required />
    <mat-error *ngIf="formGroup.controls.yieldQuantity.hasError('required')"> {{ 'YIELD_REQUIRED' | translate }} </mat-error>
    <mat-error *ngIf="formGroup.controls.yieldQuantity.hasError('pattern')"> {{ 'ERRORS_PARAMETER_NOT_INT' | translate }}</mat-error>
  </mat-form-field>
  <mat-form-field appearance="fill">
    <mat-label>{{ 'UNITE' | translate }}</mat-label>
    <mat-select id="RecipesYieldUnitBtn" formControlName="yieldUnit" required>
      <div id="RecipesNewUnitLst">
        <mat-option *ngFor="let unit of yieldUnits | filterBy : 'QUANTITY' : 'type' : 'key' | sortBy : 'name'" [value]="unit.key">
          {{ market && lang && unit.name[market] ? unit.name[market][lang] : '' }} ({{ unit['en'] ? unit['en'] : unit['fr'] }})
        </mat-option>
      </div>
    </mat-select>
    <mat-error *ngIf="formGroup.controls.yieldUnit.hasError('required')"> {{ 'YIELD_REQUIRED' | translate }} </mat-error>
  </mat-form-field>
</div>
